import { render, staticRenderFns } from "./SendTransactionView.vue?vue&type=template&id=6bb3f85b"
import script from "./SendTransactionView.vue?vue&type=script&lang=js"
export * from "./SendTransactionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports